// Publication handlers for domain-specific logic
// These functions help determine button targets, routing, and publication-specific behavior
// Based on GE016 - Smart Feed specification v1.1

export const getButtonTarget = (publicationId, domain, type) => {
  // Map publication IDs to routes based on GE016 specification
  const routeMap = {
    // ===== FINANCIAL PUBLICATIONS (247-293) =====
    // Section 5.3 - Financial Publications
    247: '/gestionoperations', // ID 247 – Add Operation (Actionable)
    248: '/', // ID 248 – Define Notification (Actionable) - Settings accessed via UserOptions modal from home
    249: '/Fistatement', // ID 249 – Define Tax Rates (Actionable)
    250: '/MonPatrimoine', // ID 250 – Monthly Wealth Summary (Summary)
    251: '/MonPatrimoine', // ID 251 – Yearly Wealth Summary (Summary)
    252: '/Fistatement', // ID 252 – Total Income (Monthly) (Summary)
    253: '/Fistatement', // ID 253 – Total Income (Yearly) (Summary)
    254: '/Fistatement', // ID 254 – Passive Income Monthly (Positive) (Summary)
    255: '/Fistatement', // ID 255 – Passive Income Monthly (Negative) (Summary)
    256: '/Fistatement', // ID 256 – Passive Income Yearly (Positive) (Summary)
    257: '/Fistatement', // ID 257 – Passive Income Yearly (Negative) (Summary)
    258: '/Monbudget', // ID 258 – Budget Monthly (Positive) (Summary)
    259: '/Monbudget', // ID 259 – Budget Monthly (Negative) (Summary)
    260: '/Monbudget', // ID 260 – Budget Yearly (Positive) (Summary)
    261: '/Monbudget', // ID 261 – Budget Yearly (Negative) (Summary)
    262: '/Fistatement', // ID 262 – Investment Rentability (7 Days) (Summary)
    263: '/Fistatement', // ID 263 – Investment Rentability (7 Days) (Summary)
    265: '/Fistatement', // ID 265 – Investment Rentability (30 Days) (Summary)
    267: '/Fistatement', // ID 267 – Investment Rentability (12 Months) (Summary)
    268: '/Fistatement', // ID 268 – Expense Breakdown (Monthly) (Summary)
    269: '/Fistatement', // ID 269 – Expense Breakdown (Yearly) (Summary)
    270: '/gestionoperations', // ID 270 – Operations Reminder (Reminder)
    271: '/mesobjectifs', // ID 271 – Objectives Update Reminder (Reminder)
    // ID 272-288 – Motivational (News) - No specific route needed, handled by NewsCard
    289: '/Fistatement', // ID 289 – News publication (News)
    290: '/Fistatement', // ID 290 – News publication (News)
    291: '/Fistatement', // ID 291 – News publication (News)
    292: '/Fistatement', // ID 292 – News publication (News)
    293: '/Fistatement', // ID 293 – News publication (News)
    
    // ===== TIME PUBLICATIONS (294-314) =====
    // Section 5.4 - Time Publications
    294: '/mesobjectifs', // ID 294 – Définis tes objectifs de temps (Actionable)
    295: '/todos/projects?action=new-task', // ID 295 – Crée ta première tâche (Actionable)
    244: '/mesobjectifs', // ID 244 – Découvre ton style de gestion du temps (Actionable) - Map to objectives since settings route doesn't exist
    238: '/todos/note?action=new-note', // ID 238 – Capture ce qui compte (Actionable)
    237: '/todos/note?action=new-note', // ID 237 – Libère ta tête, structure ton action (Actionable)
    236: '/mesobjectifs', // ID 236 – Donne vie à tes ambitions (Actionable) - Map to objectives since roadmap route doesn't exist
    235: '/MonCalendrier?view=day', // ID 235 – Prends le contrôle de ton temps (Actionable)
    313: '/MonCalendrier?view=day', // ID 313 – Ton équilibre perso / pro est respecté (Publication)
    306: '/MonCalendrier?view=day', // ID 306 – Ton temps n'est pas aligné (Publication)
    305: '/MonCalendrier?view=day', // ID 305 – Ton temps reflète tes priorités (Publication)
    302: '/MonCalendrier', // ID 302 – Ton année attend une direction (Reminder)
    301: '/MonCalendrier', // ID 301 – Ton mois n'est pas encore posé (Reminder)
    300: '/MonCalendrier', // ID 300 – Ta semaine manque de structure (Reminder)
    299: '/todos', // ID 299 – Ta journée est presque vide (Reminder)
    298: '/todos/projects?action=new-project', // ID 298 – Un projet est en sommeil (Reminder)
    297: '/todos', // ID 297 – Des échéances approchent (Reminder)
    314: '/MonCalendrier', // ID 314 – Ton équilibre perso / pro est désaligné (Summary)
    312: '/MonCalendrier', // ID 312 – Qualité de ton temps sur l'année (Summary)
    311: '/MonCalendrier', // ID 311 – Qualité de ton temps ce mois-ci (Summary)
    310: '/MonCalendrier', // ID 310 – Qualité de ton temps cette semaine (Summary)
    309: '/todos', // ID 309 – Ce que tu as accompli cette semaine (Summary)
    308: '/todos', // ID 308 – Tes projets ce mois-ci (Summary)
    307: '/todos', // ID 307 – Tes projets sur l'année (Summary)
    304: '/MonCalendrier', // ID 304 – Où passe ton temps sur l'année (Summary)
    303: '/MonCalendrier', // ID 303 – Où passe ton temps ce mois-ci (Summary)
    
    // ===== ADMINISTRATIVE PUBLICATIONS (315-320) =====
    // Section 5.5 - Administrative Publications
    315: '/documents', // ID 315 – Centralisez vos documents administratifs (Actionable)
    316: '/documents', // ID 316 – Un document arrive bientôt à échéance (Reminder)
    317: '/documents', // ID 317 – Un document administratif a expiré (Reminder)
    318: '/documents', // ID 318 – Actualité administrative locale (News)
    319: '/documents', // ID 319 – Actualité nationale à connaître (News)
    320: '/documents', // ID 320 – Changement administratif important (News)
    
    // ===== PLANET PUBLICATIONS (321-327) =====
    // Section 5.6 - Planet Publications
    321: '/Dashboard', // ID 321 – Évaluez votre empreinte carbone alimentaire (Actionable)
    322: '/Dashboard', // ID 322 – Votre empreinte carbone en un coup d'œil (Summary)
    323: '/Dashboard', // ID 323 – Votre trajectoire carbone annuelle (Publication)
    324: '/domicile/mesvehicules', // ID 324 – Mettez à jour le kilométrage de vos véhicules (Reminder)
    325: '/Dashboard', // ID 325 – Actualité planète & écologie (News)
    326: '/Dashboard', // ID 326 – Une astuce simple pour réduire votre impact (News)
    327: '/Dashboard', // ID 327 – Fixez un objectif pour votre empreinte carbone (Actionable)
    
    // ===== HOME PUBLICATIONS (354-361) =====
    // Section 5.7 - Home Publications
    354: '/domicile/mesvehicules', // ID 354 – Ajoutez votre véhicule à votre espace Home (Actionable)
    355: '/domicile/monimmobilier', // ID 355 – Renseignez votre logement (Actionable)
    356: '/domicile/entretien', // ID 356 – Anticipez l'entretien de vos biens (Actionable)
    357: '/domicile/entretien', // ID 357 – Un entretien est prévu prochainement (Reminder)
    358: '/domicile/entretien', // ID 358 – Un entretien est en retard (Reminder)
    359: '/domicile/mesvehicules', // ID 359 – Actualité concernant votre véhicule (News)
    360: '/domicile/monimmobilier', // ID 360 – Actualité autour de votre logement (News)
    361: '/domicile/monimmobilier', // ID 361 – Information utile pour votre type de bien (News)
    
    // ===== PERSONAL PUBLICATIONS (365-366) =====
    // Section 5.8 - Personal Publications
    365: '/Menu', // ID 365 – Créez votre premier menu (Actionable)
    366: '/Menu', // ID 366 – Planifiez votre menu de la semaine (Reminder)
    
    // ===== ROADMAP PUBLICATIONS (367-399) =====
    // Section 5.9 - Roadmap Publications
    // Note: /roadmap route doesn't exist, mapping to /mesobjectifs (objectives) or /BucketList (bucket list)
    367: '/roadmap?action=new-dream', // ID 367 – Créez votre première idée (Actionable)
    368: '/mesobjectifs', // ID 368 – Définissez votre horizon temporel (Actionable) - Map to objectives
    369: '/mesobjectifs', // ID 369 – Liez votre idée à l'exécution (Actionable) - Map to objectives
    370: '/mesobjectifs', // ID 370 – Fragmentez votre idée (Actionable) - Map to objectives
    // ID 371-392: Additional roadmap publications (News/Motivational) - handled generically
    371: '/mesobjectifs', // ID 371 – Roadmap news/motivational
    372: '/mesobjectifs', // ID 372 – Roadmap news/motivational
    373: '/mesobjectifs', // ID 373 – Roadmap news/motivational
    374: '/mesobjectifs', // ID 374 – Roadmap news/motivational
    375: '/mesobjectifs', // ID 375 – Roadmap news/motivational
    376: '/mesobjectifs', // ID 376 – Roadmap news/motivational
    377: '/mesobjectifs', // ID 377 – Roadmap news/motivational
    378: '/mesobjectifs', // ID 378 – Roadmap news/motivational
    379: '/mesobjectifs', // ID 379 – Roadmap news/motivational
    380: '/mesobjectifs', // ID 380 – Roadmap news/motivational
    381: '/mesobjectifs', // ID 381 – Roadmap news/motivational
    382: '/mesobjectifs', // ID 382 – Roadmap news/motivational
    383: '/mesobjectifs', // ID 383 – Roadmap news/motivational
    384: '/mesobjectifs', // ID 384 – Roadmap news/motivational
    385: '/mesobjectifs', // ID 385 – Roadmap news/motivational
    386: '/mesobjectifs', // ID 386 – Roadmap news/motivational
    387: '/mesobjectifs', // ID 387 – Roadmap news/motivational
    388: '/mesobjectifs', // ID 388 – Roadmap news/motivational
    389: '/mesobjectifs', // ID 389 – Roadmap news/motivational
    390: '/mesobjectifs', // ID 390 – Roadmap news/motivational
    391: '/mesobjectifs', // ID 391 – Roadmap news/motivational
    392: '/mesobjectifs', // ID 392 – Roadmap news/motivational
    // Section 5.9.1-5.9.10 - Professional Publications (393-399)
    393: '/parcourspro?action=new-experience', // ID 393 – Créez votre parcours professionnel (Actionable)
    394: '/mesobjectifs?action=new-work-time', // ID 394 – Saisissez votre temps de travail (Actionable)
    395: '/professionnelle?action=complete-profile', // ID 395 – Clarifiez vos aspirations professionnelles (Actionable)
    396: '/parcourspro', // ID 396 – Évaluez vos soft skills (Actionable) - Map to professional journey
    397: '/parcourspro', // ID 397 – Actualité liée à votre métier (News) - if job defined
    398: '/parcourspro', // ID 398 – Actualité liée à votre métier (News) - if job defined
    399: '/parcourspro', // ID 399 – Actualité liée à votre métier (News) - if job defined
    
    // ===== SOCIAL PUBLICATIONS (403-405) =====
    // Section 5.10 - Social Publications
    403: '/MesContacts', // ID 403 – Ajoutez un nouveau contact (Actionable)
    404: '/MesContacts', // ID 404 – Évolution de votre réseau (Summary)
    405: '/inbox', // ID 405 – Vous avez un message non lu (Reminder)
  };

  return routeMap[publicationId] || null;
};

/**
 * Navigate to button_target: internal routes via navigate(), external URLs in a new tab.
 * @param {string} target - button_target value (internal path or full http(s) URL)
 * @param {function} navigate - React Router navigate
 * @param {object} [publication] - optional; uses button_target_open_new_tab when set
 */
export const goToButtonTarget = (target, navigate, publication) => {
  if (!target || typeof target !== 'string') return;
  const t = target.trim();
  const openNewTab =
    publication?.button_target_open_new_tab === true ||
    t.startsWith('http://') ||
    t.startsWith('https://');
  if (openNewTab) {
    window.open(t, '_blank', 'noopener,noreferrer');
  } else {
    navigate(t);
  }
};

export const getDomainColor = (domain) => {
  const domainColors = {
    Finance: '#10b981',
    Time: '#f59e0b',
    Administrative: '#6366f1',
    Planet: '#06b6d4',
    Home: '#06b6d4',
    Habitation: '#06b6d4',
    Personal: '#8b5cf6',
    Roadmap: '#9c27b0',
    Professional: '#3b82f6',
    Social: '#ec4899',
  };
  return domainColors[domain] || '#6366f1';
};

export const getPublicationTypeIcon = (type) => {
  const icons = {
    Actionable: '🎯',
    Reminder: '⏰',
    Publication: '💡',
    Summary: '📊',
    News: '📰',
    Motivational: '✨',
  };
  return icons[type] || '📄';
};

export const shouldShowUpgradePrompt = (publication, subscription) => {
  // Check subscription visibility based on GE016 spec Section 5.11
  // Uses visible_for_free, visible_for_standard, visible_for_premium fields
  // from define_publication object
  
  // Get visibility fields from publication's define_publication object
  const definePublication = publication.define_publication || publication;
  const visibleForFree = definePublication.visible_for_free !== undefined 
    ? definePublication.visible_for_free 
    : true; // Default to visible if field doesn't exist (backward compatibility)
  const visibleForStandard = definePublication.visible_for_standard !== undefined 
    ? definePublication.visible_for_standard 
    : true;
  const visibleForPremium = definePublication.visible_for_premium !== undefined 
    ? definePublication.visible_for_premium 
    : true;
  
  // Normalize subscription level to lowercase
  const subscriptionLevel = (subscription || 'FREE').toLowerCase();
  
  // Check visibility based on subscription level
  if (subscriptionLevel === 'free' && !visibleForFree) {
    return true; // Show upgrade prompt for free users if not visible
  }
  if (subscriptionLevel === 'standard' && !visibleForStandard) {
    return true; // Show upgrade prompt for standard users if not visible
  }
  if (subscriptionLevel === 'premium' && !visibleForPremium) {
    return false; // Premium users should always have access
  }
  
  // Backward compatibility: Check old requires_premium/requires_standard fields
  if (publication.requires_premium && subscriptionLevel !== 'premium') {
    return true;
  }
  if (publication.requires_standard && subscriptionLevel === 'free') {
    return true;
  }
  
  return false;
};

// LAP-733 (GE022) round 10 fix-up — caller passes the BCP-47 locale
// resolved from getUserLanguage(siteUser); we keep 'fr-FR' as a safe default
// so legacy call-sites that don't pass a locale still render something.
export const formatPublicationDate = (dateString, locale = 'fr-FR') => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString(locale, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
};

export default {
  getButtonTarget,
  goToButtonTarget,
  getDomainColor,
  getPublicationTypeIcon,
  shouldShowUpgradePrompt,
  formatPublicationDate,
};
